const INTERNAL_ORIGIN = "https://campaign-engine.invalid";

function containsControlCharacter(value: string): boolean {
  return Array.from(value).some((character) => {
    const codePoint = character.codePointAt(0) ?? 0;
    return codePoint <= 0x1f || codePoint === 0x7f;
  });
}

/**
 * Return a normalized same-origin application path, or null for external and malformed input.
 * This guard is for routes read from database-backed task, suggestion, or configuration records.
 */
export function getSafeInternalPath(value: unknown): string | null {
  if (typeof value !== "string") return null;

  const candidate = value.trim();
  if (!candidate.startsWith("/") || candidate.startsWith("//")) return null;

  let decoded: string;
  try {
    decoded = decodeURIComponent(candidate);
  } catch {
    return null;
  }

  if (
    decoded.startsWith("//") ||
    decoded.includes("\\") ||
    containsControlCharacter(decoded)
  ) {
    return null;
  }

  try {
    const url = new URL(candidate, INTERNAL_ORIGIN);
    if (url.origin !== INTERNAL_ORIGIN) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function internalPathOrFallback(value: unknown, fallback: string): string {
  return getSafeInternalPath(value) ?? fallback;
}
